import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, FileText, Smartphone } from 'lucide-react';
export function TrustSection() {
  const badges = [{
    icon: ShieldCheck,
    text: 'Pago 100% seguro'
  }, {
    icon: Zap,
    text: 'Acceso inmediato'
  }, {
    icon: FileText,
    text: 'Formato digital PDF'
  }, {
    icon: Smartphone,
    text: 'Ideal para celular o computadora'
  }];
  return <section className="py-16 px-6 lg:px-8 bg-brand-dark text-white border-y border-slate-800" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8" data-id="element-178">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center gap-3" data-id="element-179">
              <div className="p-4 bg-slate-800 rounded-2xl text-brand-accent" data-id="element-180">
                <badge.icon className="w-8 h-8" data-id="element-181" />
              </div>
              <span className="font-medium text-slate-300 text-sm md:text-base" data-id="element-182">
                {badge.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}